/**
 * ```
 * 微应用配置选项:
 * name: 微应用名称 ( 确保唯一, 用于 qiankun 容器 id 的生成 )
 * entry: 微应用入口地址 ( html-entry )
 * container: 主应用挂载容器的 div id ( 该属性需要 div id 唯一, 避免冲突 )
 * activeRule: 微应用的唯一标识符, 路由匹配成功则加载对应的微应用
 * props: {
 *     id: 主要用于百度统计动态加载远程 JS 所需要的容器 ID
 *     code: 唯一标识符 ( 与平台的设置保持一致, 用于鉴权 )
 *     mounted: 微应用加载成功后的自定义处理
 * }
 *
 * eg,.
 *
 * const getActiveRule = (name) => {
 *     return window.__POWERED_BY_QIANKUN__ ? process.env.VUE_APP_MICRO_BASE_URL + name : name
 * }
 *
 * {
 *     name: 'microapp-portal',
 *     entry: '//micro-portal.foxconn.com',
 *     container: '#microapp-viewport',
 *     activeRule: '/portal',
 *     props: {
 *         code: 'portal',
 *         id: 'foxconn-microapp-portal-baidu-statistics',
 *         mounted: () => {
 *             var _hmt = _hmt || [];
 *             (function () {
 *                 var hm = document.createElement("script");
 *                 hm.src = "https://hm.baidu.com/hm.js?b91f28395d30a7ecc7bf60c90c98179f";
 *                 hm.id = scriptIds.portal
 *                 var s = document.getElementsByTagName("script")[0];
 *                 s.parentNode.insertBefore(hm, s);
 *             })()
 *         }
 *     }
 * }
 * {
 *     name: 'microapp-admin',
 *     entry: '//192.168.8.113:8082',
 *     container: '#microapp-portal-viewport',
 *     activeRule: getActiveRule('/admin')
 * }
 * ```
 */

const scriptIds = {
    portal: 'foxconn-microapp-portal-baidu-statistics',
    platform: 'foxconn-microapp-admin-baidu-statistics'
}

export const microApps = [
    // portal
    {
        name: 'micro-frontend-portal',                  // 确保唯一, 用于 qiankun 容器 id 的生成
        entry: process.env.VUE_APP_MICRO_PROTAL_ENTRY,  // 子应用入口地址
        container: '#microapp-viewport',                // 该字段属性不用变更
        activeRule: '/portal',                          // 路由匹配规则 ( 匹配成功则加载对应子应用 )
        props: {
            id: scriptIds.portal,
            mounted: () => {                            // 加载完成后的处理
                // 百度统计
                var _hmt = _hmt || [];
                (function () {
                    var hm = document.createElement("script");
                    hm.src = "https://hm.baidu.com/hm.js?b91f28395d30a7ecc7bf60c90c98179f";
                    hm.id = scriptIds.portal
                    var s = document.getElementsByTagName("script")[0];
                    s.parentNode.insertBefore(hm, s);
                })();
            }
        }
    },
    // 承揽商Admin
    {
        name: 'micro-frontend-labor',
        entry: process.env.VUE_APP_MICRO_LABOR_ADMIN_ENTRY,
        container: '#microapp-viewport',
        activeRule: '/labor',
    },
]

// 默认加载的子应用 ( 路由匹配规则 )
export const defaultApp = '/portal'

export default microApps